<template lang="html">
  <div class="center">
    <img src="@/assets/wip.svg">
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  position: fixed;
  z-index: 1; // changed the index value: 3;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
}
</style>
